import axios from 'axios';
import httpStatuses from '../constants/httpStatuses';
import { createLogger } from '../services/logger';

const logger = createLogger('api/client');

const getDefaultClient = () => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  client.interceptors.request.use(
    config => {
      return config;
    },
    error => {
      error.message = `DefaultClient::interceptor::request error - ${error.message}`;
      logger.error(error);
      return Promise.reject(error);
    },
  );

  client.interceptors.response.use(
    response => response,
    error => {
      const errorMessage = error ? error.message : 'An error ocurred';
      const httpStatus = error.response ? error.response.status : null;

      if (httpStatus === httpStatuses.UNAUTHORIZED) {
        window.location.replace('/' + window.location.pathname.split('/')[1] + '/sessao-expirada'); // TODO: Find better way to redirect
      }

      logger.error(
        `DefaultClient::interceptor::response status:${httpStatus} message:${errorMessage}`,
      );

      return Promise.reject(error);
    },
  );

  return client;
};

const getDefaultVendor = () => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  client.interceptors.request.use(
    config => {
      return config;
    },
    error => {
      error.message = `DefaultClient::interceptor::request error - ${error.message}`;
      logger.error(error);
      return Promise.reject(error);
    },
  );


  client.interceptors.response.use(
    response => response,
    error => {
      const errorMessage = error ? error.message : 'An error ocurred';
      const httpStatus = error.response ? error.response.status : null;

      logger.error(
        `DefaultClient::interceptor::response status:${httpStatus} message:${errorMessage}`,
      );
      return Promise.reject(error);
    },
  );

  return client;
};

const getPrivateClient = sessionId => {
  const client = getDefaultClient();

  client.interceptors.request.use(
    config => {
      if (sessionId) {
        config.headers.Authorization = `vivo ${sessionId}`;
      }

      return config;
    },
    error => {
      error.message = `PrivateClient::interceptor::request error - ${error.message}`;
      logger.error(error);
      return Promise.reject(error);
    },
  );

  return client;
};

const getEldoradoClient = () =>
  axios.create({
    baseURL: process.env.REACT_APP_ELDORADO_API_URL,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

const publicClient = getDefaultClient();
const publicVendor = getDefaultVendor();

const privateClient = sessionId => getPrivateClient(sessionId);

const eldoradoClient = getEldoradoClient();

export { publicClient, privateClient, eldoradoClient, publicVendor };
